var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h3',[_c('a',{attrs:{"id":"_0"}}),_vm._v("排序实现")]),_c('p',[_vm._v("默认排序推荐在前端配置"),_c('br'),_vm._v(" 参照文档"),_c('a',{attrs:{"href":"#"}},[_vm._v("前端排序")])])])])
}]

export { render, staticRenderFns }